var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{class:_vm.$style['message-date']},[(!_vm.isToday)?_c('div',[_vm._v(_vm._s(_vm.dateDay))]):_vm._e(),_c('div',[_vm._v(_vm._s(_vm.dateTime))])])])}
var staticRenderFns = []

export { render, staticRenderFns }